import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const skeletonStyles = makeStyles()(() => ({
	container: {
		display: 'flex',
		width: '100%',
		position: 'relative',
		overflowX: 'hidden',
	},
	icon: {
		flexGrow: 1,
	},
	animation: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		transform: 'translateX(100%)',
		zIndex: 1,
		animation: 'slide 1s infinite 0s',
		background:
			'linear-gradient(to right, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.8) 75%, rgba(128, 186, 232, 0) 99%, rgba(125, 185, 232, 0) 100%)',
	},
}));

export const keyframes = `
  @keyframes slide {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
